import React, { useState, useEffect, useCallback } from "react";

import { ActionBar, Sticky } from "@plex/react-components";

import { ActionBarLink } from "ui/app/navigation";
import { useLocalizedValues } from "ui/hooks";
import { RoleMembersHistory } from "ui/screens/security/role-members-history";
import { securityMessages } from "ui/screens/security/security.localization";

import { ISecurityRole } from "../SecurityRoles.state";

export interface ISecurityRolesActionBarProps {
  selectedRow?: ISecurityRole;
}

export const SecurityRolesActionBar: React.FC<ISecurityRolesActionBarProps> = ({ selectedRow }) => {
  const localizedValues = useLocalizedValues(() => ({
    viewRoleMembersHistory: securityMessages.action("viewRoleMembersHistory")
  }));

  const shouldDisableViewRoleMemberHistoryButton = useCallback(() => {
    return !selectedRow;
  }, [selectedRow]);

  const [viewRoleMemberHistoryButtonState, setViewRoleMemberHistoryButtonState] = useState<{ disabled: boolean }>(() => ({
    disabled: shouldDisableViewRoleMemberHistoryButton()
  }));

  useEffect(() => {
    setViewRoleMemberHistoryButtonState(prev => ({
      ...prev,
      disabled: shouldDisableViewRoleMemberHistoryButton()
    }));
  }, [shouldDisableViewRoleMemberHistoryButton]);

  return (
    <Sticky>
      <ActionBar>
        <ActionBarLink
          disabled={viewRoleMemberHistoryButtonState.disabled}
          text={localizedValues.viewRoleMembersHistory}
          title={localizedValues.viewRoleMembersHistory}
          dialog={{
            content: <RoleMembersHistory tenantId={selectedRow ? selectedRow.tenant.tenantId : ""} securityRoleId={selectedRow ? selectedRow.roleId : ""} />
          }}
        />
      </ActionBar>
    </Sticky>
  );
};
